<div
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-at="picker-fields"
>
  <div class="modal__content">
    <div class="modal__content__header">
      <div class="navbar navbar--sub">
        <div class="navbar__section navbar__section--title">
          {{ data.title | translate }}
        </div>
        <div class="navbar__section navbar__section--right">
          <gk-help-menu [isSmallIcon]="true" class="tw-mt-2"></gk-help-menu>
          <gk-icon-button icon="close" (buttonClick)="close()"></gk-icon-button>
        </div>
      </div>
      <div
        class="alert alert--error"
        *ngIf="tradeCroppingRecordsForm.submitted && tradeCroppingRecordsForm.theForm.invalid"
      >
        <div class="alert__content">
          <i data-icon></i>
          <span>{{ 'TRADE_CROPPING_RECORDS_AREA_ERROR' | translate }}</span>
          <button
            class="btn btn--primary u-pull-left"
            (click)="tradeCroppingRecordsForm.submitted = false"
          >
            Ok
          </button>
        </div>
      </div>
    </div>

    <div class="modal__content__picker !tw-max-h-full">
      <ul class="nav nav-tabs" gk-picker-tabs>
        <li [ngClass]="{ 'active' : availableList }">
          <a (click)="showAvailableList()"
            >{{ 'CROPPING_RECORDS' | translate }}</a
          >
        </li>
        <li [ngClass]="{ 'active' : selectedList }">
          <a (click)="showSelectedList()"
            >{{ 'SELECTED' | translate }}
            ({{selectedCroppingRecords.length}})</a
          >
        </li>
      </ul>

      <gk-picker-wrapper
        class="container container--row container--np table-list"
      >
        <gk-picker
          class="grid-6 container container--column container--np"
          [attr.is-visible]="availableList"
        >
          <header class="toolbar">
            <div class="toolbar__section">
              <span class="modal_sub_header_left_label"
                >{{ 'ALL_FIELDS' | translate }}</span
              >
              <gk-filter
                [(filterText)]="filterText"
                [filterWhenNoText]="false"
                (filterEvent)="filterChange()"
                [hideFilter]="true"
                placeholder="{{ 'FIELDS_FILTER_PLACE_HOLDER' | translate }}"
                data-at="filter"
                cdkFocusInitial
                class="tw-pr-3"
              ></gk-filter>
              <gk-field-filter
                (updateUserPreferences)="userPreferencesModified($event)"
                [isSingleBusiness]="true"
                [businessId]="businessId"
              ></gk-field-filter>
            </div>
          </header>

          <div class="table" gk-table-scroll-height>
            <div
              class="table__section table__section--head"
              [ngClass]="{ 'table-header-scrollbar-padding': hasVerticalScrollBar('allContainer') }"
            >
              <table>
                <tr>
                  <th colspan="3">
                    <div class="u-ellipsis">{{ 'FIELD' | translate }}</div>
                  </th>
                  <th colspan="3" *ngIf="hasSequencedRecords">
                    <div class="u-ellipsis">{{ 'SEQUENCE' | translate }}</div>
                  </th>
                  <th colspan="2">
                    <div class="u-ellipsis">{{ 'FARM' | translate }}</div>
                  </th>
                  <th colspan="2" class="u-text-right">
                    <div class="u-ellipsis">{{ 'AREA_HA' | translate }}</div>
                  </th>
                  <th class="table__row__cell--control"></th>
                </tr>
              </table>
            </div>

            <div
              id="allContainer"
              class="table__section table__section--body"
              [ngClass]="{ 'is-empty' : filteredCroppingRecords.length === 0 }"
            >
              <div
                class="u-ellipsis muted"
                *ngIf="filteredCroppingRecords.length === 0"
              >
                {{ 'NO_CROPPING_RECORDS_MESSAGE' | translate }}
              </div>
              <table *ngIf="filteredCroppingRecords.length > 0">
                <tr
                  *ngFor="let croppingRecord of filteredCroppingRecords"
                  gkTableAccessibility
                  tabindex="0"
                  [ngClass]="{ 'is-selected' : croppingRecord.selected }"
                  (click)="addCroppingRecord(croppingRecord)"
                  data-at="unpicked-item"
                >
                  <td colspan="3">
                    <div class="u-ellipsis">
                      <div data-at="item-name">
                        {{ croppingRecord.fieldName }}
                      </div>
                      <div
                        [attr.failedCrop]="
                          croppingRecord.isFailed === true ? '' : null
                        "
                        class="small muted"
                        data-at="item-metaInfo"
                      >
                        {{ croppingRecord | cropLandUse: '-' }}
                      </div>
                    </div>
                  </td>
                  <td colspan="3" *ngIf="hasSequencedRecords">
                    <div class="u-ellipsis">
                      <i
                        *ngIf="croppingRecord.sequenceName"
                        data-icon="job-completed"
                        [class.sequence-current]="croppingRecord.currentCrop"
                      ></i>
                      {{ croppingRecord | sequenceName }}
                    </div>
                  </td>
                  <td colspan="2">
                    <div class="u-ellipsis">
                      {{ croppingRecord.fieldGroupName }}
                    </div>
                  </td>
                  <td colspan="2" class="u-text-right">
                    <div class="u-ellipsis" data-at="area">
                      {{ croppingRecord.fieldArea | number : '1.4-4' }}
                    </div>
                  </td>
                  <td
                    class="table__row__cell--control"
                    *ngIf="!croppingRecord.selected"
                  >
                    <gk-icon-button icon="add_circle" size="compact">
                    </gk-icon-button>
                  </td>
                  <td
                    class="table__row__cell--control"
                    *ngIf="croppingRecord.selected"
                  ></td>
                </tr>
              </table>
            </div>
          </div>

          <div class="toolbar">
            <div class="toolbar__section toolbar__section--left">
              <gk-button
                (buttonClick)="selectAllCroppingRecords()"
                label="{{ 'SELECT_ALL' | translate }}"
              >
              </gk-button>
            </div>
            <div class="toolbar__section toolbar__section--right">
              <gk-checkbox
                *ngIf="showSequencesCheckbox"
                label="{{ 'SHOW_CURRENT_CROPS_ONLY' | translate }}"
                (changeEvent)="toggleCurrentCrop()"
                [ngModel]="hideCurrentCrop"
                [align]="'after'"
                dataAt="checkbox-hideCurrentCrop"
              >
              </gk-checkbox>
            </div>
          </div>
        </gk-picker>

        <gk-picker
          class="grid-6 container container--column container--np"
          [attr.is-visible]="selectedList"
        >
          <header class="toolbar">
            <div class="toolbar__section">
              <span class="modal_sub_header_left_label"
                >{{ 'SELECTED_FIELDS' | translate }}</span
              >
            </div>
          </header>

          <gk-edit-trade-cropping-records-form
            (saveForm)="saveTradeCroppingRecords()"
            [selectedCroppingRecords]="selectedCroppingRecords"
            (croppingRecordRemoved)="removeCroppingRecord($event)"
          >
          </gk-edit-trade-cropping-records-form>

          <div class="toolbar">
            <div class="toolbar__section toolbar__section--left">
              <gk-button
                (buttonClick)="removeAllCroppingRecords()"
                label="{{ 'REMOVE_ALL' | translate }}"
              >
              </gk-button>
            </div>
            <div class="toolbar__section toolbar__section--right">
              <gk-icon-button
                type="submit"
                btnType="square-fill"
                icon="check"
                size="compact"
                (buttonClick)="tradeCroppingRecordsForm.save()"
                data-at="button-save"
              >
              </gk-icon-button>
            </div>
          </div>
        </gk-picker>
      </gk-picker-wrapper>
    </div>
  </div>
</div>
